var _defs, _polygon, _polygon2, _line, _path, _polygon3, _polygon4, _line2, _g, _g2, _circle, _circle2, _g3, _line3, _line4, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefineholylogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0, .st1 {\n        fill: none;\n      }\n\n      .st0, .st1, .st2 {\n        stroke-miterlimit: 10;\n      }\n\n      .st0, .st2 {\n        stroke: #B8860B;\n        stroke-width: 2px;\n      }\n\n      .st1 {\n        stroke: #8B0000;\n        stroke-width: 1.25px;\n        stroke-dasharray: 120;\n        animation: twinkle 12s linear infinite;\n      }\n\n      .ray1 .st1:nth-child(1) { animation-delay: 0s; }\n      .ray1 .st1:nth-child(2) { animation-delay: 1.8s; animation-name: twinkle-deep; }\n      .ray1 .st1:nth-child(3) { animation-delay: 3.9s; }\n      .ray2 .st1:nth-child(1) { animation-delay: 2.5s; }\n      .ray2 .st1:nth-child(2) { animation-delay: 0.6s; }\n      .ray2 .st1:nth-child(3) { animation-delay: 4.7s; animation-name: twinkle-deep; }\n      .ray3 .st1:nth-child(1) { animation-delay: 3.2s; animation-name: twinkle-deep; }\n      .ray3 .st1:nth-child(2) { animation-delay: 5.1s; }\n      .ray3 .st1:nth-child(3) { animation-delay: 1.1s; }\n      .ray4 .st1:nth-child(1) { animation-delay: 4.4s; }\n      .ray4 .st1:nth-child(2) { animation-delay: 2.8s; animation-name: twinkle-deep; }\n      .ray4 .st1:nth-child(3) { animation-delay: 0.3s; }\n\n      @keyframes twinkle {\n        0%, 15% { stroke-dasharray: 120 0; }\n        40%, 55% { stroke-dasharray: 75 45; animation-timing-function: ease-out; }\n        85%, 100% { stroke-dasharray: 120 0; }\n      }\n\n      @keyframes twinkle-deep {\n        0%, 15% { stroke-dasharray: 120 0; }\n        40%, 55% { stroke-dasharray: 52 68; animation-timing-function: ease-out; }\n        85%, 100% { stroke-dasharray: 120 0; }\n      }\n\n      .st2 {\n        fill: #B8860B;\n      }\n    "))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "457.05 181.24 421.13 160.5 342.37 181.24 421.13 201.98 457.05 181.24"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "227.69 181.24 263.61 201.98 342.37 181.24 263.61 160.5 227.69 181.24"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 227.69,
    y1: 181.24,
    x2: 457.05,
    y2: 181.24
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M354.83,337.49h-21.95l1.04-2.88,1.69-3.44v-54.43h14.15v53.77c0,1.22,1.64,2.43,1.64,3.65,0,2.18,3.43,1.15,3.43,3.33Z"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "342.37 295.92 363.11 260 342.37 181.24 321.63 260 342.37 295.92"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "342.37 66.55 321.63 102.48 342.37 181.23 363.11 102.48 342.37 66.55"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 342.37,
    y1: 66.55,
    x2: 342.37,
    y2: 295.92
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "ray1"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 343.41,
    y1: 178.74,
    x2: 271.82,
    y2: 255.29
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 343.41,
    y1: 178.74,
    x2: 291.33,
    y2: 209.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 343.41,
    y1: 178.74,
    x2: 312.99,
    y2: 236.08
  })), /*#__PURE__*/React.createElement("g", {
    className: "ray2"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 342.71,
    y1: 179.49,
    x2: 414.3,
    y2: 102.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 342.71,
    y1: 179.49,
    x2: 394.79,
    y2: 148.61
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 342.71,
    y1: 179.49,
    x2: 373.12,
    y2: 122.15
  })), /*#__PURE__*/React.createElement("g", {
    className: "ray3"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 340.23,
    y1: 179.23,
    x2: 416.78,
    y2: 250.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 340.23,
    y1: 179.23,
    x2: 371.11,
    y2: 231.32
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 340.23,
    y1: 179.23,
    x2: 397.57,
    y2: 209.65
  })), /*#__PURE__*/React.createElement("g", {
    className: "ray4"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 342.37,
    y1: 181.24,
    x2: 265.82,
    y2: 109.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 342.37,
    y1: 181.24,
    x2: 311.48,
    y2: 129.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 342.37,
    y1: 181.24,
    x2: 285.03,
    y2: 150.82
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 342.37,
    y1: 181.24,
    x2: 352.29,
    y2: 262.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 342.37,
    y1: 181.24,
    x2: 331.71,
    y2: 263.21
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 341.71,
    y1: 182.2,
    x2: 331.79,
    y2: 101.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 341.71,
    y1: 182.2,
    x2: 352.37,
    y2: 100.23
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 341.58,
    y1: 180.87,
    x2: 260.7,
    y2: 190.79
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 341.58,
    y1: 180.87,
    x2: 259.61,
    y2: 170.21
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 340.62,
    y1: 180.21,
    x2: 421.51,
    y2: 170.29
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 340.62,
    y1: 180.21,
    x2: 422.6,
    y2: 190.87
  }))))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 342.37,
    cy: 181.23,
    r: 21.03
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 342.37,
    cy: 181.23,
    r: 9.92
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 342.37,
    y1: 171.92,
    x2: 342.37,
    y2: 190.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 336.17,
    y1: 178.04,
    x2: 348.57,
    y2: 178.04
  }))), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 342.08,
    y1: 180.78,
    x2: 342.37,
    y2: 181.24
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 342.37,
    y1: 181.68,
    x2: 342.7,
    y2: 182.2
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#4B0082"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M95.69,266.97c1.87-.2,3.08-.53,3.65-1.01.57-.47.85-1.67.85-3.59v-22.79c0-1.87-.28-3.07-.83-3.6-.55-.53-1.78-.87-3.68-1v-.95h13.81c4.65,0,8.59.77,11.81,2.3,5.8,2.75,8.7,7.67,8.7,14.76,0,2.55-.52,4.98-1.56,7.28-1.04,2.3-2.61,4.24-4.71,5.83-1.33,1-2.72,1.76-4.15,2.28-2.62.97-5.84,1.45-9.65,1.45h-14.23v-.95ZM106,265.62c.41.27,1.25.4,2.54.4,4,0,7.29-.79,9.88-2.38,3.97-2.44,5.95-6.6,5.95-12.49,0-5.26-1.63-9.21-4.9-11.87-2.8-2.27-6.51-3.4-11.13-3.4-1.15,0-1.93.13-2.34.38-.41.25-.61.8-.61,1.65v26.06c0,.83.2,1.39.61,1.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.76,246.9c1.77,1.63,2.65,3.93,2.65,6.92h-15.88c.17,3.86,1.04,6.67,2.63,8.44s3.46,2.65,5.63,2.65c1.75,0,3.23-.46,4.43-1.37,1.2-.92,2.31-2.21,3.33-3.89l.88.3c-.68,2.12-1.96,4.08-3.84,5.89-1.88,1.8-4.17,2.71-6.89,2.71-3.14,0-5.56-1.18-7.27-3.55s-2.56-5.09-2.56-8.18c0-3.35.99-6.24,2.98-8.68,1.98-2.43,4.57-3.65,7.75-3.65,2.35,0,4.41.81,6.18,2.44ZM137.78,248.82c-.53.9-.92,2.03-1.15,3.4h10.55c-.18-1.67-.5-2.91-.95-3.73-.82-1.47-2.18-2.2-4.1-2.2s-3.35.84-4.35,2.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.59,267.22c1.77-.08,2.93-.41,3.49-.99.56-.58.84-1.79.84-3.64v-16.06h-4.28v-1.68h4.28c0-2.63.36-4.86,1.08-6.68,1.37-3.48,3.88-5.23,7.54-5.23,1.47,0,2.78.29,3.95.88,1.16.58,1.74,1.37,1.74,2.35,0,.55-.2,1.04-.6,1.48s-.88.65-1.44.65c-.48,0-.9-.15-1.24-.44-.35-.29-.76-.8-1.24-1.54l-.42-.65c-.23-.35-.51-.65-.82-.89-.32-.24-.75-.36-1.32-.36-1.26,0-2.12.63-2.56,1.88-.25.67-.37,1.54-.37,2.63v5.93h6.23v1.68h-6.23v16.06c0,1.88.25,3.09.76,3.61s1.84.86,3.99,1.01v.7h-13.36v-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.65,267.22c1.78-.17,2.91-.47,3.38-.91.47-.44.7-1.64.7-3.59v-11.93c0-1.08-.07-1.83-.23-2.25-.25-.68-.78-1.03-1.58-1.03-.18,0-.36.02-.54.05-.18.03-.68.17-1.51.4v-.78l1.08-.35c2.92-.95,4.95-1.67,6.1-2.15.47-.2.77-.3.9-.3.03.12.05.24.05.38v17.96c0,1.9.23,3.09.69,3.58.46.48,1.5.79,3.11.93v.7h-12.16v-.7ZM176.62,233.78c.5-.51,1.12-.77,1.85-.77s1.33.25,1.84.76c.51.51.76,1.12.76,1.85s-.25,1.32-.76,1.83c-.51.51-1.12.76-1.84.76s-1.35-.25-1.85-.76c-.5-.51-.75-1.12-.75-1.83s.25-1.33.75-1.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.8,267.22c1.18-.15,2.01-.45,2.49-.89.48-.44.71-1.43.71-2.96v-12.71c0-1.06-.1-1.8-.3-2.23-.32-.63-.97-.94-1.95-.94-.15,0-.3,0-.46.02-.16.02-.35.04-.59.08v-.88c.68-.2,2.3-.72,4.85-1.55l2.35-.78c.12,0,.19.04.21.12.03.08.04.2.04.35v3.68c1.53-1.43,2.73-2.42,3.6-2.95,1.3-.82,2.65-1.23,4.04-1.23,1.13,0,2.16.33,3.1.98,1.8,1.27,2.7,3.53,2.7,6.78v11.68c0,1.2.24,2.07.72,2.6.48.53,1.28.81,2.41.83v.7h-10.68v-.7c1.22-.17,2.07-.5,2.55-1.01.48-.51.73-1.61.73-3.31v-10.68c0-1.43-.27-2.62-.8-3.56-.53-.94-1.51-1.41-2.93-1.41-.98,0-1.97.33-2.98,1-.56.38-1.29,1.02-2.19,1.9v14.01c0,1.2.27,2.01.8,2.41.53.41,1.38.63,2.53.66v.7h-10.93v-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.4,246.9c1.77,1.63,2.65,3.93,2.65,6.92h-15.88c.17,3.86,1.04,6.67,2.63,8.44s3.46,2.65,5.63,2.65c1.75,0,3.23-.46,4.43-1.37,1.2-.92,2.31-2.21,3.33-3.89l.88.3c-.68,2.12-1.96,4.08-3.84,5.89-1.88,1.8-4.17,2.71-6.89,2.71-3.14,0-5.56-1.18-7.27-3.55s-2.56-5.09-2.56-8.18c0-3.35.99-6.24,2.98-8.68,1.98-2.43,4.57-3.65,7.75-3.65,2.35,0,4.41.81,6.18,2.44ZM217.42,248.82c-.53.9-.92,2.03-1.15,3.4h10.55c-.18-1.67-.5-2.91-.95-3.73-.82-1.47-2.18-2.2-4.1-2.2s-3.35.84-4.35,2.53Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M166.42,331.41c2.79-.3,4.53-.82,5.23-1.54.7-.73,1.05-2.63,1.05-5.71v-30.94c0-2.56-.39-4.22-1.17-4.99-.78-.77-2.48-1.24-5.11-1.43v-1.33h19.81v1.33c-2.61.19-4.31.66-5.1,1.43-.79.77-1.18,2.43-1.18,4.99v13.92h21.7v-13.92c0-2.56-.38-4.22-1.15-4.99-.77-.77-2.48-1.24-5.13-1.43v-1.33h19.81v1.33c-2.63.19-4.33.66-5.11,1.43-.78.77-1.17,2.43-1.17,4.99v31.78c0,2.59.39,4.25,1.17,4.98.78.73,2.48,1.21,5.11,1.44v1.33h-19.81v-1.33c2.81-.28,4.56-.79,5.25-1.53.69-.74,1.03-2.65,1.03-5.73v-13.88h-21.7v14.72c0,2.59.39,4.26,1.18,5,.79.74,2.49,1.21,5.1,1.42v1.33h-19.81v-1.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.09,304.81c2.94-3.2,6.73-4.8,11.35-4.8s8.42,1.51,11.44,4.53c3.02,3.02,4.53,7.05,4.53,12.07,0,4.63-1.47,8.65-4.4,12.07-2.93,3.42-6.72,5.13-11.37,5.13s-8.24-1.64-11.34-4.92c-3.09-3.28-4.64-7.4-4.64-12.35,0-4.63,1.47-8.54,4.41-11.74ZM228.66,303.92c-2.33,2.12-3.49,5.77-3.49,10.95,0,4.14.94,8,2.81,11.58,1.88,3.58,4.48,5.37,7.81,5.37,2.61,0,4.62-1.2,6.03-3.59,1.41-2.39,2.11-5.53,2.11-9.42s-.9-7.81-2.69-11.37c-1.79-3.56-4.39-5.34-7.79-5.34-1.84,0-3.44.6-4.79,1.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.04,331.75c2.16-.21,3.63-.65,4.4-1.31.77-.66,1.15-1.96,1.15-3.89v-34.08c0-1.53-.13-2.59-.38-3.17-.47-.98-1.41-1.47-2.83-1.47-.33,0-.68.04-1.06.1s-.87.17-1.45.31v-1.15c3.14-.84,6.92-1.95,11.34-3.35.16,0,.26.07.3.21.04.14.05.44.05.91v41.82c0,2.02.35,3.33,1.05,3.92.7.59,2.14.97,4.33,1.13v.98h-16.88v-.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.4,300.67h14.72v.98c-1.16.02-2.02.13-2.58.32-1.07.31-1.6.92-1.6,1.82,0,.33.06.67.17,1.02.12.34.33.86.63,1.55l8.07,17.46,6.65-17.6c.07-.19.18-.62.33-1.29.15-.67.23-1.12.23-1.36,0-.62-.21-1.07-.63-1.36-.42-.29-.95-.45-1.6-.5l-1.08-.07v-.98h9.59v.98c-.95.12-1.67.46-2.15,1.01-.48.55-.89,1.32-1.24,2.31l-10.99,29.09c-1.91,5.02-3.73,8.66-5.48,10.92-1.74,2.25-3.95,3.38-6.63,3.38-1.3,0-2.52-.33-3.66-.98-1.14-.65-1.71-1.69-1.71-3.1,0-.93.34-1.69,1.02-2.28.68-.59,1.53-.89,2.57-.89.6,0,1.49.22,2.67.66s2.03.66,2.53.66c1.29,0,2.64-1.58,4.06-4.74,1.42-3.16,2.14-5.24,2.14-6.25,0-.21-.03-.46-.1-.76-.07-.3-.14-.56-.23-.79l-10.99-23.77c-.79-1.72-1.48-2.85-2.08-3.4-.59-.55-1.47-.9-2.63-1.06v-.98Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefineholylogo);
export default __webpack_public_path__ + "static/media/defineholylogo.577581d9a1e14c902e89da764a3c25bf.svg";
export { ForwardRef as ReactComponent };